<script lang="ts" setup>
export interface PagesDocumentsPageHeaderProps {
    title: string
}

const props = defineProps<PagesDocumentsPageHeaderProps>()

const handleSearch = (value: string): void => {
    // get route
    const route = useNamedRoutes({
        name: 'search',
        query: {
            q: value,
            filter: 'document',
            all_categories: 'false',
        },
    })
    // redirect to the route
    window.location.href = route
}
</script>
<template>
  <ContainerFluid class="mt-12 mt-md-20 mb-12">
    <PageHeaderSearch
      :action="useNamedRoutes({ name: 'documents' })"
      heading-type="h1"
      :title="props.title"
      @submit="handleSearch"
    />
  </ContainerFluid>
</template>
